import http from "./httpService";

const apiEndPoint = "/gchatbots/";

function getGchatBots() {
  return http.get(apiEndPoint);
}

export default getGchatBots;
